<template>
  <div class="add modal modal--default">
    <div class="modal__panel" :class="showAddFamilyMemberModal ? 'modal__panel--in' : 'modal__panel--out'">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
      </div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="add__new">{{ $t(`addFamilyMemberModal.${"title"}`) }}</div>

      <div class="add__title">{{ $t(`addFamilyMemberModal.${"subTitle"}`) }}</div>

      <div class="customers">
        <div class="customer" @click="showSearchMemberModal()">
          <div class="customer__icon customer__icon--search"></div>
          <button class="add__button button button--default">
            {{ $t(`addFamilyMemberModal.${"searchButton"}`) }}
          </button>
        </div>
        <div class="customer" @click="showAddCustomerModal()">
          <div class="customer__icon customer__icon--add"></div>
          <button class="add__button button button--default">
            {{ $t(`addFamilyMemberModal.${"addButton"}`) }}
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

// Component name definition
defineOptions({
  name: "AddFamilyMember"
});

const store = useStore();

// Computed properties mapping your original Vuex Getters
const showAddFamilyMemberModal = computed(() => store.getters.showAddFamilyMemberModal);

// Operational Methods
const closeModal = () => {
  store.commit("setIsAddingCustomer", false);
  store.commit("setIsAddingPotentialCustomer", false);
  store.commit("setShowAddCustomerModal", false);
  store.commit("setShowAddFamilyMemberModal", false);
};

const showAddCustomerModal = () => {
  store.commit("setIsAddingCustomer", true);
  store.commit("setIsAddingMember", true);
  store.commit("setShowAddFamilyMemberModal", false);
  store.commit("setShowAddCustomerModal", true);
};

const showSearchMemberModal = () => {
  store.commit("setShowAddFamilyMemberModal", false);
  store.commit("setShowAddSearchFamilyMemberModal", true);
};
</script>
<style scoped lang="scss">
@use "../assets/scss/add-panel-modal";
</style>
